










































































































































































import { defineComponent, PropType, SetupContext } from '@vue/composition-api';

import BaseButton from '@/base/app/components/atoms/BaseButton.vue';
import BaseButtonCheckbox from '@/base/app/components/atoms/BaseButtonCheckbox.vue';
import BaseButtonIcon from '@/base/app/components/atoms/BaseButtonIcon.vue';
import ProblemNavigator from '@/base/app/components/atoms/ProblemNavigator.vue';
import ContentFooter from '@/base/app/components/molecules/ContentFooter.vue';
import ProblemView from '@/base/app/components/molecules/ProblemView.vue';
import { ProblemUtilsNavigator, ProblemUtilsProblem } from '@/base/app/utils/ProblemUtils';
import { GetCourseContentDetailsContent } from '@/contents/usecases';

import { PropsContentExam, useContentExam } from './ContentExamComposable';
import ContentHeaderDialog from './ContentHeaderDialog.vue';
import ExamBodyDialog from './ExamBodyDialog.vue';
import ExamPassingStandardDialog from './ExamPassingStandardDialog.vue';
import ProblemListDialog from './ProblemListDialog.vue';

type Props = PropsContentExam;

export default defineComponent({
  name: 'ContentsContentExam',
  components: {
    BaseButton,
    BaseButtonCheckbox,
    BaseButtonIcon,
    ProblemNavigator,
    ProblemView,
    ContentFooter,
    ContentHeaderDialog,
    ProblemListDialog,
    ExamBodyDialog,
    ExamPassingStandardDialog,
  },
  model: { prop: 'index', event: 'change' },
  props: {
    index: { type: Number, default: 0 },
    content: { type: Object as PropType<GetCourseContentDetailsContent>, required: true },
    problems: { type: Array as PropType<ProblemUtilsProblem[]>, default: () => [] },
    problemNavigator: { type: Object as PropType<ProblemUtilsNavigator>, default: undefined },
    isConfirmedEditing: { type: Boolean, default: false },
    hide: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['change', 'choice-value', 'toggle-flag', 'click-anchor', 'refresh'],
  setup(props: Props, { emit }: SetupContext) {
    return useContentExam(props, emit);
  },
});
